const PROD_ID = 'GTM-5P8FXJ';
const QA_ID = 'GTM-K38MFVK';

const PROD_QS = '';
const QA_QS = '&gtm_auth=EooEAfCZ9TFXW4xjZ1fXCA&gtm_preview=env-55&gtm_cookies_win=x';
const DEV_QS = '&gtm_auth=UbbN_A4eWDkvSIJ-0I6qZA&gtm_preview=env-6&gtm_cookies_win=x';

export const TAG_MANAGER_ENVIRONMENT = {
  production: {
    id: PROD_ID,
    query: PROD_QS,
  },
  qa: {
    id: QA_ID,
    query: QA_QS,
  },
  development: {
    query: DEV_QS,
  },
};
